import { Button, Flex, H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { Esemplare } from "../../types"
import EsemplareForm from "./EsemplareForm"
import { useNavigate, useParams } from "react-router-dom"
import { Formik } from "formik"
import { initialValuesEsemplare, validationSchemaEsemplare } from "./EsemplareCommon"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import useModalTrigger from "magik-react-hooks/useModalTrigger"
import ModalDelete from "../../components/ModalDelete"
import { useMemo } from "react"
import { useEsemplare, useEsemplareUpdate, useEsemplareDelete } from "../../hooks/esemplari"
import { ScrollLayout } from "../../components/ScrollLayout"
import { transformErrorForForm } from "../../utils/utils"

export default function EsemplareUpdate() {
  const updateEsemplare = useEsemplareUpdate()
  const navigate = useNavigate()

  const { id } = useParams()

  const { data: esemplare } = useEsemplare(Number(id))

  const [modalStateDeleteEsemplare, modalActionsDeleteEsemplare] = useModalTrigger()

  const deleteEsemplare = useEsemplareDelete()

  const initialValues = useMemo(() => initialValuesEsemplare(esemplare), [esemplare])
  const validationSchema = useMemo(() => validationSchemaEsemplare(true), [])

  useBreadcrumbs([{ label: "Esemplari", href: "/edizioni/esemplari" }, { label: "Dettaglio Esemplare" }])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <Flex alignItems="center" justifyContent="between">
          <H1>{esemplare?.codice || <>&nbsp;</>}</H1>
          <Button
            size="md"
            variant="danger"
            title="Elimina"
            leadingIcon="delete"
            onClick={() => {
              modalActionsDeleteEsemplare.open()
            }}
          />
        </Flex>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, actions) => {
              return updateEsemplare.mutateAsync(values as Esemplare).then(() => {
                navigate(`/edizioni/esemplari`)
              }).catch((e) => {
                actions.setErrors(transformErrorForForm(e))
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <EsemplareForm showEdizione col={8} />
                </Container>
                <BottomFormFixed url="/edizioni/esemplari" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
      <ModalDelete
        isOpen={modalStateDeleteEsemplare.isOpen}
        onClose={modalActionsDeleteEsemplare.close}
        onDelete={() => {
          return deleteEsemplare.mutateAsync(esemplare?.id).then(() => {
            navigate(`/edizioni/esemplari`)
          })
        }}
        message="Sei sicuro di voler eliminare questo esemplare?"
        title="Elimina esemplare"
      />
    </Layout>
  )
}
